export default __webpack_public_path__ + "static/inviteYourOwnRetroMac-9958df47872ae036544edc6d89070b4e.jpg";